/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HomeHealthCertificationResult } from './HomeHealthCertificationResult';
import {
    HomeHealthCertificationResultFromJSON,
    HomeHealthCertificationResultFromJSONTyped,
    HomeHealthCertificationResultToJSON,
    HomeHealthCertificationResultToJSONTyped,
} from './HomeHealthCertificationResult';

/**
 * 
 * @export
 * @interface FindCurrentHomeHealthCertification200Response
 */
export interface FindCurrentHomeHealthCertification200Response {
    /**
     * 
     */
    data: HomeHealthCertificationResult;
}

/**
 * Check if a given object implements the FindCurrentHomeHealthCertification200Response interface.
 */
export function instanceOfFindCurrentHomeHealthCertification200Response(value: object): value is FindCurrentHomeHealthCertification200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function FindCurrentHomeHealthCertification200ResponseFromJSON(json: any): FindCurrentHomeHealthCertification200Response {
    return FindCurrentHomeHealthCertification200ResponseFromJSONTyped(json, false);
}

export function FindCurrentHomeHealthCertification200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindCurrentHomeHealthCertification200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': HomeHealthCertificationResultFromJSON(json['data']),
    };
}

export function FindCurrentHomeHealthCertification200ResponseToJSON(json: any): FindCurrentHomeHealthCertification200Response {
    return FindCurrentHomeHealthCertification200ResponseToJSONTyped(json, false);
}

export function FindCurrentHomeHealthCertification200ResponseToJSONTyped(value?: FindCurrentHomeHealthCertification200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HomeHealthCertificationResultToJSON(value['data']),
    };
}

